<template>
  <div class="about">
    <div id="head-page" class="meubles parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/meubles-03.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/meubles-01.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/meubles-02.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container">
       <div class="grid-x grid-margin-x">
         <div class="small-12 medium-8 medium-offset-2 cell content-page">

           <title-page attrpage="Globulo Quest" baseline="Dans l'aventure Globulo Quest">Nos partenaires</title-page>

            <p>Octobre
            2017, <a target="_blank" href="https://www.youtube.com/watch?v=3SoMcxpjKDI"><strong>Hack’
            A Fond</strong></a> de la
            fondation B Braun&nbsp;: début de l’aventure.</p>



            <p>5
            téméraires se lancent un défi. Sur une idée de Romain ils
            conçoivent un projet de santé digitale destiné aux jeunes enfants
            leucémiques sous l’égide de la <a target="_blank" href="http://www.leucemie-espoir.org/"><strong>FEDERATION
            LEUCEMIE ESPOIR</strong></a>.</p>



            <p>Bientôt
            réduite à 3, l’équipe&nbsp;: Aurélie (coordinatrice), Romain et
            Michel, donnent naissance à <strong>GLOBULO
            QUEST,</strong> chacun
            apportant, à sa façon, sa pierre à l’édifice.</p>



            <p>Depuis
            de nombreux mois, notre team a connu des élans de solidarité, a su
            s’entourer de soutiens et a bénéficié de la générosité de
            précieux partenaires. Tous méritent bien d’être cités.
            </p>



            <p>–
            Commençons par la <a target="_blank" href="https://www.bbraun.fr/fr/entreprise/fondation.html"><strong>Fondation
            d’Entreprise B Braun</strong></a>
            qui a cru en ce projet en Octobre 2017 et lui a attribué un prix lui
            permettant de voir le jour. Les questions pointues soulevées par les
            jurés experts de la santé digitale pendant notre pitch nous ont
            permis de concevoir une solution digitale viable, utile et, nous
            l’espérons, agréable.</p>



            <p>–
            La<strong> <a target="_blank" href="https://www.capfi.fr/">société
            CAPFI&nbsp;</a></strong>:
            Rodolphe Bellanguez nous a spontanément proposé son concours et mis
            en relation avec ses collaborateurs François Cherpion et Fabien
            Janot. Ces deux conseillers techniques ont contribué à ce que le
            projet décolle. Quant à Nathalie Charpy elle nous a accompagnés
            sur les aspects juridiques.
            </p>



            <p>–
            L’<a target="_blank" href="https://www.sparadrap.org/"><strong>association
            Sparadrap</strong></a> qui
            possède beaucoup d’expertise en pédagogie et diffusion de
            l’information auprès d’enfants nous a ouvert sa bibliothèque de
            documents pratiques illustrés pour informer les enfants et leurs
            proches sur toutes les situations de soins.</p>



            <p>–
            <strong>Hervé Bismut</strong>,
            expert en santé digitale omniprésent à nos côtés, nous a fait
            bénéficier de son réseau.</p>



            <p>
            –  Le<strong>
            Conseil Scientifique</strong>
            et principalement&nbsp;: Nadia Marquis, Chloé Aregui, Véronique
            Tanguy du service d’hémato-immuno-oncologie de l’hôpital
            Trousseau, Laurence Stengel assistante sociale également à
            Trousseau, ainsi que Morgane Pouget et Bénédicte Marchina-Andurand,
            psychologues cliniciennes de l’hôpital Robert Debré et Catherine
            Alderic, assistante sociale à l’hôpital Saint louis nous ont
            confortés et orientés dans nos choix.</p>



            <p>–
            <strong>Guillaume Aubourg</strong>
            à des moments importants du projet nous a fait bénéficier de son
            éclairage et nous a mis en relation avec notre prestataire web.</p>



            <p>–
            L’<strong><a target="_blank" href="http://www.dezup.com/">agence
            web DEZUP</a>,</strong> au
            travers de Vincent Ginet et Benjamin Sanchez, a en charge le
            développement de notre projet et représente un prestataire très
            apprécié et efficace.</p>



            <p>–
            La commission partenariat d’<strong><a target="_blank" href="https://www.harmonie-mutuelle.fr/web/tout-harmonie">Harmonie
            Mutuelle – Région Grand Est</a> </strong>a
            été la première entité à nous apporter son soutien financier.</p>



            <p>–
            <a target="_blank" href="https://www.mutualia.fr/le-groupe/en-region/mutualia-territoires-solidaires/mecenat/"><strong>Mutualia
            Territoires Solidaires</strong></a>
            lui a emboîté le pas et nous accompagne également avec beaucoup
            d’enthousiasme en ayant retenu notre dossier dans le cadre d’un
            appel à projets.</p>



            <p>–
             La<strong> <a target="_blank" href="https://www.leem.org/fondation-des-entreprises-du-medicament-pour-lacces-aux-soins">Fondation
            des Entreprises du Médicament (LEEM)</a></strong>
            pour l’accès aux soins, de la même manière, a reconnu le bien
            fondé de notre démarche et a plébiscité notre projet en devenant
            partenaire financier.</p>



            <p>–
            <a target="_blank" href="http://www.mecene-et-loire.fr/"><strong>Mécène
            et Loire</strong></a> a
            également sélectionné notre projet pour l’accompagner dans le
            cadre d’un appel à projets local, le siège de la Fédération
            leucémie Espoir étant localisé dans le Maine et Loire.</p>



            <p>–
            <a target="_blank" href="https://ensemble-en-regions.fr/regions/grand-est/"><strong>La Société Générale délégation régionale du Grand Est </strong></a>
             soutient aussi le développement de notre outil.
            </p>

            <p>– Un grand merci également à Elias Gérard et François Talbot de chez <a target="_blank" href="https://pitchtree.eu/"><strong>Pitchtree</strong></a> a  qui nous ont permis de bénéficier de l'expertise et de la motivation d'une équipe travaillant chez <a target="_blank" href="https://www.probtp.com/particuliers-accueil.html"><strong> Pro BTP</strong></a>dans le cadre de leur formation. Merci à Anne-Laure Bagarry, Noël Geeraert, Emmanuel Guyonnet, Catherine Ledogar, Guillaume Verlaine et Serge Verrando.
            </p>



            <p>Merci
            à tous pour leur engagement fort à nos côtés, pour leur œil
            averti pour certains et pour leur technique sûre pour les autres.</p>



            <p>L’équipe
            Globulo Quest.</p>



         </div>

       </div>
     </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import BoxContribuer from '@/components/sidebar/BoxContribuer'
  import BandeauImage from '@/components/BandeauImage'
  export default {
    components: { TitlePage, BoxContribuer, BandeauImage },
  }
</script>
